// DEV-60. Строка исхода обновления: показывается оператору и на успех, и на
// отказ — с номером станции и причиной. Отдельным компонентом, чтобы отказ
// станции, отказ STM и отказ ESP проверялись одним и тем же способом.

import React from "react";
import {
  describeFirmwareOutcome,
  FirmwareOutcome,
} from "../firmwareStatus";

interface FirmwareOutcomeNoticeProps {
  outcome: FirmwareOutcome;
}

const FirmwareOutcomeNotice: React.FC<FirmwareOutcomeNoticeProps> = ({
  outcome,
}) => {
  const failed = outcome.outcome === "failure";

  return (
    <div
      className={`FW-outcome ${failed ? "FW-outcome-failed" : "FW-outcome-complete"}`}
      role="status"
      data-outcome={outcome.outcome}
      data-component={outcome.component || ""}
      data-reason={outcome.reason || ""}
      data-station={outcome.stationNumber === null ? "" : String(outcome.stationNumber)}
      style={{
        marginTop: "10px",
        padding: "8px",
        borderRadius: "4px",
        backgroundColor: failed ? "#fdecec" : "#eaf7ea",
        color: failed ? "#a32020" : "#1f6b1f",
      }}
    >
      {describeFirmwareOutcome(outcome)}
    </div>
  );
};

export default FirmwareOutcomeNotice;
